export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5198.740d71b3.jpg";